import { Skeleton } from 'primereact/skeleton';
import { isMobile } from 'react-device-detect';
const ShopLoader = () => {
    return (
        <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-5 mx-4'>
            {Array.from({ length: 8 }).map((_, i) => (
                <div key={i}>
                    <Skeleton height='15rem' className="mb-2"></Skeleton>
                    <div className='flex justify-between'>
                        <div>
                            <Skeleton width={isMobile ? '7rem': '12rem'} className="my-3"></Skeleton>
                            <Skeleton width={isMobile ? '5rem': '10rem'}  className="mb-2"></Skeleton>
                        </div>
                        <div className='mt-2'>
                            <Skeleton width="3rem" height='3rem' borderRadius='4rem' className="mb-2"></Skeleton>
                        </div>
                    </div>
                </div>
            ))}
        </div>

    );
}

export default ShopLoader;